// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__Bznei","description":"PatientConsentPreview_description__3M4jA"};